import React from 'react';
import PropTypes, { any } from 'prop-types';
import {
    ToggleSwitch,
} from '../../../Form';

const PreventDivisionDateRegistration = (props) => {
    const {
        field,
        formApi,
        eventHasSameDateDivisions,
        setShowPopup,
    } = props;

    return (
        <div className={`col-12`}>
            <ToggleSwitch
                id={'preventDivisionDateRegistrationConflicts'}
                field={field}
                formGroupCssClass={`mb16`}
                label="Prevent players from registering for more than one division on a given date."
                isEventEditForm

                onChange={(val) => {
                    if (!val) {
                        formApi.setValue('preventDivisionDateRegistrationConflicts', false);
                        formApi.setError(false);
                    }
                    if (val) {
                        if (eventHasSameDateDivisions) {
                            setShowPopup(true);
                        }
                    }
                }}
                reverse={false}
            />
            <div className="div div16" />

        </div>
    );
};
PreventDivisionDateRegistration.propTypes = {
    field: PropTypes.string.isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
    eventHasSameDateDivisions: PropTypes.bool,
    setShowPopup: PropTypes.bool,
};
PreventDivisionDateRegistration.defaultProps = {
    eventHasSameDateDivisions: false,
    setShowPopup: false,
};
export default PreventDivisionDateRegistration;
